import { render, staticRenderFns } from "./wordDialog.vue?vue&type=template&id=60a5c568&scoped=true"
import script from "./wordDialog.vue?vue&type=script&lang=js"
export * from "./wordDialog.vue?vue&type=script&lang=js"
import style0 from "./wordDialog.vue?vue&type=style&index=0&id=60a5c568&prod&lang=scss&scoped=true"
import style1 from "./wordDialog.vue?vue&type=style&index=1&id=60a5c568&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60a5c568",
  null
  
)

export default component.exports